import React from 'react';

import { ReactComponent as IconSad } from '@skippay/core/assets/illustrations/icon-brambora-sad.svg';
import Button from '@skippay/core/components/Button';
import Link from '@skippay/core/components/Link';
import Modal from '@skippay/core/components/Modal';
import ModalContent from '@skippay/core/components/ModalContent';
import Text from '@skippay/core/components/Text';
import { FormattedMessage, useIntl } from '@skippay/core/i18n/intl';

import { BUDGET_BAKERS_ERROR_MODAL } from 'sections/KYC/constants';
import { KYCModalType } from 'sections/KYC/types/modals';

interface Props {
	type: KYCModalType;
	resetView: () => void;
	setIsBudgetBakersCancelled: (isCancelled: boolean) => void;
	onModalClose: () => void;
	handleTrackScreen?: (screen: typeof BUDGET_BAKERS_ERROR_MODAL) => void;
}

function BudgetBakersErrorModal(props: Props): JSX.Element {
	const intl = useIntl();
	const handleTryAgainClick = () => {
		props.resetView();
		props.onModalClose();
	};
	const handleUseUploadClick = () => {
		props.resetView();
		props.setIsBudgetBakersCancelled(true);
		props.onModalClose();
	};

	props.handleTrackScreen?.(BUDGET_BAKERS_ERROR_MODAL);

	return (
		<Modal
			contentLabel={intl.formatMessage({
				defaultMessage: 'Připojení k bance selhalo',
				id: 'AccountUpgrade.BudgetBakersErrorModal.contentLabel',
			})}
			name="budgetBakersErrorModal"
			shouldCloseOnOverlayClick={false}
			small
			isOpen
		>
			<ModalContent
				testId="BudgetBakersErrorModal"
				Header={
					<Text as="h1" size="h3" align="center">
						<FormattedMessage
							id="BudgetBakersErrorModal.heading"
							defaultMessage="Připojení k bance selhalo"
						/>
					</Text>
				}
			>
				<div className="u-m-top--23 mt-5! md:mt-0!">
					<IconSad />
				</div>
				<Text className="mt-3!">
					<FormattedMessage
						defaultMessage="Váš poskytovatel bankovních služeb teď není k dispozici. Zkuste to prosím ještě jednou později."
						id="BudgetBakersErrorModal.text"
					/>
				</Text>
				<Button
					className="mt-4!"
					onClick={handleTryAgainClick}
					testId="tryAgain"
					analyticsId="tryAgain"
				>
					<FormattedMessage
						defaultMessage="Zkusit znovu"
						id="BudgetBakersErrorModal.footer.button"
					/>
				</Button>

				{props.type === 'AccountUpgrade' && (
					<Link
						className="mt-4!"
						onClick={handleUseUploadClick}
						testId="uploadFile"
						analyticsId="uploadFile"
					>
						<FormattedMessage
							defaultMessage="Nahrát výpis"
							id="BudgetBakersErrorModal.footer.link"
						/>
					</Link>
				)}
			</ModalContent>
		</Modal>
	);
}

export default BudgetBakersErrorModal;
